import setClientAllocations from './setClientAllocations';
import setClientStandardAllocations from './setClientStandardAllocations';
import setClientCrisisAllocations from './setClientCrisisAllocations';
import setClientAllocation from './setClientAllocation';
import resetPagination from './resetPagination';
import setAllocationClientsByGroup from './setAllocationClientsByGroup';
import setClientAllocationAvailability from './setClientAllocationAvailability';
import resetClientAllocationAvailability from './resetClientAllocationAvailability';

export default {
  setClientAllocations,
  setClientStandardAllocations,
  setClientCrisisAllocations,
  setClientAllocation,
  resetPagination,
  setAllocationClientsByGroup,
  setClientAllocationAvailability,
  resetClientAllocationAvailability,
};
